module.exports = __webpack_public_path__ + "img/events-active.95259abe.svg";